import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, propTypes, Field, formValueSelector } from 'redux-form';
import { mapStateToProps } from 'utils/redux-decorators';
import { DropdownFieldTags } from 'components/FormFields';
import { TextField, DropdownField } from 'components';
import { TextAreaField } from 'components/FormFields/TextAreaField';
import { Button } from 'components';
import { ROLES } from 'config/constants';
import { Validation } from 'utils/forms/validations';
import { validate } from './validate';

export const FORM_NAME = 'LinkForm';
const selector = formValueSelector(FORM_NAME);

@mapStateToProps((state) => ({
  jobTitles: selector(state, 'jobTitles'),
}))
@reduxForm({
  form: FORM_NAME,
  validate,
  enableReinitialize: true,
})
export class LinkForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    notesPlaceholder: PropTypes.string,
  };

  render() {
    const {
      handleSubmit,
      notesPlaceholder,
      jobTitles = [],
      groups,
      userRole,
      onHandleSetJobTitlesForResearchSite,
    } = this.props;
    const locationsField =
      (groups.includes(ROLES.PERSONNEL) && userRole === ROLES.RESEARCH_SITE) ||
      (groups.includes(ROLES.RESEARCH_SITE) &&
        (userRole === ROLES.PERSONNEL ||
          userRole === ROLES.PERSONNEL_INACTIVE));
    const showOtherJobTitle =
      jobTitles.includes('55') || jobTitles.includes('66');

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image mt-10 flex flex-column align-items-center justify-content-center"
      >
        {locationsField && (
          <Field
            name="locations"
            title="Location:"
            titleClassName="fs-12 form-fields__description _light _not-font"
            list={this.props.listLocations}
            component={DropdownField}
            onInputChange={onHandleSetJobTitlesForResearchSite}
            initMessage="Choose option from list of locations added..."
            initMessageClassName="dd-header-title__ligth"
            rowsCount={4}
            validate={[Validation.required]}
          />
        )}
        <Field
          name="jobTitles"
          title="Job title(s):"
          titleClassName="fs-12 form-fields__description _light _not-font"
          component={DropdownFieldTags}
          list={this.props.jobTitlesList}
          fieldClassName={locationsField && 'mt-7'}
          rowsCount={3}
          disabled={this.props.jobTitlesList.length === 0}
          search
          dropdownInputField
        />
        {showOtherJobTitle && (
          <Field
            name="jobTitleOther"
            title="Other Job Title:"
            titleClassName="fs-12 form-fields__description _light _not-font"
            component={TextField}
            placeholder="Enter text"
            fieldClassName="mt-7"
          />
        )}
        <Field
          name="note"
          title="Add notes:"
          titleClassName="fs-12 form-fields__description _light _not-font"
          component={TextAreaField}
          placeholder={notesPlaceholder}
          fieldClassName="mt-7"
        />
        <Button type="submit" className="_red mt-10" style={{ width: '180px' }}>
          Link
        </Button>
      </form>
    );
  }
}
